import React, { useState, useEffect } from "react"
import { initGA, disableGA } from "../utils/gtag"
import "../css/cookieBanner.css"

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    // Check if user has already accepted/declined cookies
    const cookieConsent = localStorage.getItem("cookieConsent")
    if (!cookieConsent) {
      // Show banner after a short delay for better UX
      setTimeout(() => {
        setShowBanner(true)
      }, 1000)
    }

    // Listen for custom event to show cookie banner from footer
    const handleShowCookieBanner = () => {
      setShowBanner(true)
    }

    window.addEventListener("showCookieBanner", handleShowCookieBanner)

    // Also expose a global function for easier access
    window.showCookieBanner = () => {
      setShowBanner(true)
    }

    return () => {
      window.removeEventListener("showCookieBanner", handleShowCookieBanner)
      delete window.showCookieBanner
    }
  }, [])

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted")
    setShowBanner(false)
    // Initialize Google Analytics when user accepts
    initGA()
  }

  const declineCookies = () => {
    localStorage.setItem("cookieConsent", "declined")
    setShowBanner(false)
    // Disable Google Analytics when user declines
    disableGA()
  }

  if (!showBanner) return null

  return (
    <div className="cookie-banner">
      <div className="cookie-banner__content">
        <p className="cookie-banner__text">
          Ta strona używa plików cookie, aby zapewnić najlepsze wrażenia. Kontynuując przeglądanie, wyrażasz zgodę na ich użycie.
        </p>
        <div className="cookie-banner__buttons">
          <button
            className="cookie-banner__button cookie-banner__button--accept"
            onClick={acceptCookies}
          >
            Akceptuję
          </button>
          <button
            className="cookie-banner__button cookie-banner__button--decline"
            onClick={declineCookies}
          >
            Odrzuć
          </button>
        </div>
      </div>
    </div>
  )
}

export default CookieBanner

